export default __webpack_public_path__ + "static/media/jinrongrenzheng.7fa7925a.png";